export default {
  install: function (Vue) {
    // 引入svg图片
    const requireAll = requireContext => requireContext.keys().map(requireContext);
    const req = require.context("@/assets/icon", true, /\.svg$/);
    const req_common = require.context("@common/src/assets/icon", true, /\.svg$/);
    requireAll(req);
    requireAll(req_common);
    // key: 组件名称，value：vue文件名称
    const f = {
      "svg-icon": "svg-icon",
      "se-footer-btns": "footer-btns",
      "se-input-phone": "input-phone",
      "se-data-empty": "data-empty",
      "se-input-password": "input-password",
      "se-table-empty": "table-empty",
      "se-input-carnum": "input-carnum"
    };
    Object.keys(f).forEach(item => {
      Vue.component(item, () => import(`./${f[item]}.vue`));
    });
  }
};
